module.exports = __webpack_public_path__ + "img/home_vip_pop_limited_time_en.5f740546.png";